import React, { useState } from 'react';
import './Login.scss';
import logo from '../../assets/OHM_1.png';
import { useNavigate } from 'react-router-dom';
import { api } from '../../Api-Endpoints/apiEndpoint';
import { useDispatch, useSelector } from 'react-redux';
import {
  userLoginFailed,
  userLoginRequest,
  userLoginSuccess,
} from '../../Redux/OauthSlice';
import MiniLoader from '../loader/MiniLoader';
import toast from 'react-hot-toast';
import { LoadProcedures } from '../../Redux/ProcedureReducer';
import { saveToPersistance } from '../../Helpers/helper';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLogedIn, user, isLoging } = useSelector(state => state.User);
  const [input, setInput] = useState({
    email: '',
    password: '',
  });

  const handleForgotPasswordClick = () => {
    navigate('/reset-password');
  };

  const unwindProcedure = pro => {
    let p = [];
    pro.forEach(_p => {
      p.push(_p.procedure);
    });
    return p;
  };

  const handleLoginClick = async () => {
    try {
      dispatch(userLoginRequest());
      const { status, data } = await api.post('/user/user-login', input);
      console.log(input);
      if (status == 200 && data.success) {
        dispatch(userLoginSuccess(data.user));
        // localStorage.setItem("auth", JSON.stringify(data?.user));
        await saveToPersistance(data?.user);
        // const _procedures = unwindProcedure(data.user._role.procedures);
        // dispatch(LoadProcedures(_procedures));
        // navigate("/dashboard");
      }
    } catch (error) {
      toast.error(error?.response?.data);
      dispatch(userLoginFailed());
    }
  };

  const onChangeInput = e => {
    const { name, value } = e.target;
    setInput(prev => ({ ...prev, [name]: value }));
  };
  // if(isLogedIn && user.role=='user'){
  //    navigate('/user-dashboard')
  // }
  if (
    (isLogedIn && user.role == 'admin') ||
    (isLogedIn && user.role == 'user')
  ) {
    navigate('/dashboard');
  }
  return (
    <>
      <div className="loginSignUp">
        <div className="main">
          <div className="left">
            <div className="image">
              <img height={40} src={logo} alt="logo" />
            </div>
            <div className="heading-sighin">
              <p>Sigh In</p>
            </div>
            <div className="input-feild">
              <input
                type="text"
                name={'email'}
                value={input.email}
                onChange={onChangeInput}
                placeholder="E-mail"
              />
              <input
                type="password"
                name={'password'}
                value={input.password}
                onChange={onChangeInput}
                placeholder="Password"
              />
            </div>
            <div className="buttens">
              <button className="login-btn" onClick={handleLoginClick}>
                {isLoging ? <MiniLoader /> : <>Login</>}
              </button>
              <button className="fp-btn" onClick={handleForgotPasswordClick}>
                Forgot Password?
              </button>
            </div>
          </div>
          <div className="right">
            <div className="head-text-combine">
              <div className="heading-welcome">
                <p>Welcome to Ohm-Hub!</p>
              </div>
              <div className="text-for-welcome">
                {/* <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Earum eum sed animi consectetur mollitia nesciunt modi cum
                  quibusdam molestias. <br />
                  <br />
                  Lorem ipsum dolor sit amet consectetur adipisicing elit
                  oluptates!
                </p> */}
              </div>
              {/* <div className="button-for-welcome">
                <button className="Privacy">Privacy Policy</button>
                <button className="terms">Terms & Condition</button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
